module.exports = __webpack_public_path__ + "img/stock0.7d36c6d6.png";